<template>
  <div class="process-runtime" v-loading = formLoading element-loading-text="正在加载，请稍候">
   <div class="main">
    <div class="form" ref="formStyle" :style="{height: formHeight,overflow: nodeTabEnable?'hidden':'auto'}">
      <!-- 分组导航栏-->
      <div v-if="showGroupNav" class="process-group-nav">
        <el-tabs tab-position="left" @tab-click="navToGroup" value="''" v-if="nodeTabEnable">
          <el-tab-pane v-for="item in getCurrentgroupComponent(nodeTab.activeName)" :key="item.id" :label="item.name" @click.native="test">
            <span slot="label" :title="item.name">{{item.name && item.name.length > 16 ? item.name.slice(0,15)+'...' : item.name}}</span>
          </el-tab-pane>
        </el-tabs>
        <el-tabs v-else tab-position="left" @tab-click="navToGroup" value="''">
          <el-tab-pane v-for="item in groupComponent" :key="item.id" :label="item.name" @click.native="test">
            <span slot="label" :title="item.name">{{item.name && item.name.length > 16 ? item.name.slice(0,15)+'...' : item.name}}</span>
          </el-tab-pane>
        </el-tabs>
      </div>
      <!-- 表单-->
      <div :class="[showGroupNav&&'process-group-nav-form', nodeTabEnable&&'box1']">
         <!-- 节点tab展示 -->
        <div :class="{'box1':nodeTabEnable}" v-if="nodeTabEnable">
          <el-tabs type="card" class="node-tab" v-model="nodeTab.activeName" v-if="getComponent.length">
            <el-tab-pane v-for="item in getComponent" :key="item.id" :label="item.name" :name="item.id">
              <span slot="label" :title="item.name">{{item.name}}</span>
              <rc-form
                v-show="hiddenForm(item)"
                ref="form"
                :value="dataService.data"
                :parentPath="[processComponent.archive.columnId]"
                :parentComponent="processComponent"
                :component="item"
                :disable="buttonlook||currentNode.formId !== item.id"
                :title="'process'"
                :dialogWidth="dialogWidth"
                :nodeTabEnable="nodeTabEnable"/>
            </el-tab-pane>
          </el-tabs>
        </div>
        <!-- 各个节点-->
        <div v-else v-for="item in getComponent" :key="item.id">
          <div>
            <rc-form
              v-show="hiddenForm(item)"
              ref="form"
              :value="dataService.data"
              :parentPath="[processComponent.archive.columnId]"
              :parentComponent="processComponent"
              :component="item"
              :disable="buttonlook||currentNode.formId !== item.id"
              :title="'process'"
              :dialogWidth="dialogWidth"/>
          </div>
        </div>
      </div>
    </div>
    <div class="comment" ref="comment">
      <el-form :model="commentForm" ref="commentForm" label-width="90px" label-position="left" v-show="!customCommit">
        <el-form-item class="superior-comment" :label="superiorComment?'上级节点意见:':''" v-if="!hasDefinitionId">
          <label v-if="superiorComment" class="el-form-item__label comment-content" :title="superiorComment">{{superiorComment}}</label>
          <label class="el-form-item__label more" @click="moreComment">更多></label>
        </el-form-item>
        <el-form-item label="审批意见"
                      v-if="currentNode.approvalOpinion"
                      prop="approvalComment"
                      :rules="getRule">
          <el-input type="textarea" v-model="commentForm.approvalComment"></el-input>
        </el-form-item>
      </el-form>
      <!-- 晟融定制意见框-->
      <process-commit class="shengrong-comment" v-show="customCommit"></process-commit>
    </div>
    <div class="candidate-button">
      <div class="candidate" v-if="nodeCandidate && nodeCandidate.length">
        <label class="node" v-for="(candiinitComponentdate, index) in nodeCandidate" :key="index">
          {{candiinitComponentdate.name}}
          <label @click="selectPerson(candiinitComponentdate.id)" :style="{color:candidatesColor[candiinitComponentdate.name]}">{{getShowAssigns(candiinitComponentdate.id).name|| '请选择'}}</label>
        </label>
      </div>
      <div class="button">
        <el-row>
          <el-button v-if="temporaryStorageEnable" :loading="staging" ref="staging" @click="temporaryStorage" :tabindex="30000">暂存</el-button>
          <el-button ref="buttons" v-for="(action,index) in currentNode.actions" :key="action.id" :tabindex="30000 + index"
                     @click="buttonClick(action.id, action.name,action)" :type="isNormalButton(action.id)?'primary':''">
            <i class="el-icon-loading" v-if="loading.activeLoadingId===action.id && (loading.isloading || loading.isCustomLoading)"></i>
            {{action.name}}
          </el-button>
          <el-button v-if="turnOnReassign&&currentNodeId!==processDefinition.process.startNode" @click="openTurnOnReassign">转交</el-button>
        </el-row>
      </div>
    </div>
      <el-dialog class="process-select-person-dialog" title="处理人" :visible.sync="selectPeople.dialogVisible" :before-close="cancel" center @open="open" append-to-body :close-on-click-modal="false">
        <div class="selected">
          <select-person
            v-if="selectPeople.dialogVisible"
            :treeData="allData"
            :single="!getIsCountersign(selectPeople.nodeId)"
            :disableType="['department']"
            :select="getSelectPersons"
            :isRadio="'radio'"
            ref="select"></select-person>
        </div>
        <div slot="footer" class="dialog-buttons">
          <el-button type="primary" @click="saveSelectPerson">保存</el-button>
          <el-button @click="cancel">取消</el-button>
        </div>
      </el-dialog>
      <approval-comment
        :dialogVisible="commentVisible"
        :approvalCommentHistory="approvalCommentHistory"
        :currentNodeId="currentNode.id"
        @close="commentVisible=false"
        :showLookBtn="false"></approval-comment>
    </div>
    <dialog-process-runtime v-if="processPublicDialog.visible" :data="processPublicDialog" :variables="dataService.data"></dialog-process-runtime>
    <dialog-form-runtime :formRuntimeDialog="rcTableFormRuntimeDialog"></dialog-form-runtime>
    <el-dialog
      class="turnon-reassign-dialog"
      title="转交"
      :visible.sync="turnOnReassignDialog.dialogVisible"
      width="540px"
      append-to-body
      center>
      <div>
       <el-form ref="turnForm" :model="turnOnReassignDialog">
         <el-form-item class="inform-scope" label="" prop="candidate" :rules="{required: true, message: '请选择转交人'}">
        <div class="inform-scope-content">
          <div class="left">转交给 <i class="el-icon-plus" @click="openDialog"></i></div>
          <div class="right">
            <span class="candidate-item" v-for="item in turnOnReassignDialog.candidate" :key="item.id">{{item.name}}</span>
          </div>
        </div>
         </el-form-item>
        <div class="turnon-tip">
          <p>转交说明</p>
          <el-input type="textarea" v-model="turnOnReassignDialog.explain"></el-input>
        </div>
        </el-form>
       </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmTurnon">确 定</el-button>
        <el-button @click="turnOnReassignDialog.dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <new-select-people v-if="selectInformDialog.visable" :data="selectInformDialog" @getCandidate="getCandidate"></new-select-people>
    <candidate-superiors v-if="candidateIsSuperiors.visible" :data="candidateIsSuperiors" @getCandidatesuperiors="getCandidatesuperiors"></candidate-superiors>
  </div>
</template>

<script>
import sdk from 'redcatSdk'
import _ from 'lodash'
import SelectPerson from '../../system/select-person'
import cache from '../../public/cache'
import RcForm from '../../form/runtime/components/rc-form'
import {FormComponent} from '../../../store/form/component'
import DataService from '../../../store/form-runtime/dataService.js'
import ApprovalComment from './approval-comment'
import {calculationMixin, interactionMixin} from '../../form/runtime/components/mixins'
import CodeService, { EventBus } from '@/store/form-runtime/codeService'
import ProcessDefinition from '@/store/process/definition'
import NewSelectPeople from '@/components/system/system/new-select-people'
import { UUID } from '@/plugins/common'
import { AsyncRequest } from '@/components/form/runtime/components/utils/AjaxRequestLimit.js'
import CandidateSuperiors from './candidate-superiors.vue'
import {TableComponent, ColumnComponent} from '@/store/form/component'
import { processNavMixin, processNodeInteraction } from './mixin'
import { rcTableEditViaForm } from '@/components/shared/runtimeMixins'
import scrollBarMixin from '@plugins/scrollBar/index'
import CookieOperation from '@/plugins/cookie'

let dataService = new DataService()

export default {
  name: 'process-runtime',
  provide () {
    return {
      dataService,
      eventBus: this.eventBus,
      initState: {},
      initCount: this.initCount,
      // 直接使用 redcatApp导致值不更新。不想再在一层所以用方法
      redcatApp: this.getRedcatApp,
      formVm: this
    }
  },
  mixins: [calculationMixin, interactionMixin, processNavMixin, processNodeInteraction, rcTableEditViaForm, scrollBarMixin],
  props: ['definitionId', 'dialogWidth', 'dialogDisabled', 'dialogDataId', 'dialogTaskId', 'formRuntimeDialog'],
  data () {
    let viewUrl = sessionStorage.getItem('ossDownloadUrl')
    return {
      eventBus: new EventBus(),
      initStateObj: {state: false, showGroupNav: false},
      nodes: [],
      processComponent: {},
      instanceId: this.formRuntimeDialog.instanceId,
      started: this.formRuntimeDialog.started,
      startedTime: this.formRuntimeDialog.startedTime,
      taskId: this.$route.params.taskId || this.dialogTaskId,
      dataId: this.$route.query.dataId || this.dialogDataId,
      buttonlook: this.$route.query.disabled || this.dialogDisabled,
      actions: [],
      selectPeople: {
        dialogVisible: false,
        nodeId: ''
      },
      allData: [],
      nodeAssigns: [],
      nodeAssign: '',
      // 当前节点信息
      currentNode: {},
      currentNodeId: '',
      // 当前选人节点
      currentSelectPersonNodeId: '',
      // 候选人节点
      nodeCandidate: [],
      // 历史节点
      historyNodeIds: [],
      // 审批意见
      commentForm: {
        approvalComment: ''
      },
      commentRequired: false,
      getRule: {required: false, message: '请输入审核意见', trigger: 'blur'},
      // 上级意见
      superiorComment: '',
      // 审批意见历史
      approvalCommentHistory: [],
      commentVisible: false,
      temporaryStorageEnable: false,
      turnOnReassign: false,
      dataService,
      withoutHandleDataService: {},
      page: {
        starting: false
      },
      hasDefinitionId: this.$route.query.definitionId || this.definitionId,
      loading: {
        isCustomLoading: false,
        isloading: false,
        activeLoadingId: ''
      },
      processPublicDialog: {
        visible: false,
        title: 'title',
        width: '30%',
        // 是否可以通过点击 modal 关闭弹窗
        closeWithClick: false,
        // 是否可以通过 esc键 关闭弹窗
        closeWithEsc: true
      },
      viewUrl: viewUrl,
      initCount: {value: 0},
      // 会签候选人
      countersignUsers: [],
      //  暂存中标识
      staging: false,
      // 转交
      turnOnReassignDialog: {
        dialogVisible: false,
        candidate: [],
        explain: ''

      },
      selectInformDialog: {
        visable: false,
        data: [],
        title: '人员选择',
        isSingle: true,
        selectType: ['user']
      },
      starter: '',
      candidateIsSuperiors: {
        visible: false,
        allPeople: []
      },
      // 并行网关的值
      inclusiveGatewayNode: {
        isInGateway: false,
        gatewayNodeIds: []
      },
      nodeTabEnable: false,
      nodeTab: {
        activeName: '',
        tempLastTabId: ''
      },
      // 是否开启了自定义意见栏（为晟融租户专用）
      customCommit: false,
      // 晟融意见的高度
      customCommitHeight: 0,
      //  65th 表单加载loading
      formLoading: false,
      candidatesColor: {}
    }
  },
  components: {
    DialogProcessRuntime: () => {
      return Promise.resolve(sdk.components.DialogProcessRuntime)
    },
    SelectPerson,
    RcForm,
    ApprovalComment,
    NewSelectPeople,
    CandidateSuperiors,
    DialogFormRuntime: () => import('@/components/shared/dialog-form-runtime.vue'),
    ProcessCommit: () => {
      return Promise.resolve(sdk.components.ProcessCommit)
    }
  },
  async created () {
    let tenantId = CookieOperation.get('tenantId')
    if (tenantId === '16DB9E8F-4B50-003D-9ED7-32C247B72173') {
      this.formLoading = true
    }
    dataService = new DataService()
    // 二次加载的时候, 这两货居然不是同一个对象了
    this._provided.dataService = this.dataService
    this._provided.initState = this.initStateObj
    // 直属上级的情况
    this.candidateIsSuperiors.allPeople = await this.getUserSuperior()

    await this.loadForm()
    if (this.dataId) {
      await this.loadData(this.dataId)
    } else {
      await this.buildData()
    }
    //  判断单前节点是不是并行网关中的一个。如果当前节点是 并行网关的某一个节点的时候  把并行的其他节点的归档值清空提交
    if (this.taskId) {
      this.gatewayNodes()
    }
    this._provided.initState.historyNodeIds = this.historyNodeIds
    this._provided.initState.currentNodeId = this.currentNodeId

    // 为了历史节点不计算,返回节点不计算,返回后的下一个节点计算
    this._provided.initState.type = 'process'

    const customProcessDialog = {
      openProcessPublicDialog: (params) => {
        _.assign(this.processPublicDialog, params)
      }
    }
    const codeService = new CodeService({eventBus: this.eventBus, process: {define: this.processComponent, dataService: this.dataService, currentNode: this.currentNode, customProcessDialog: customProcessDialog, withoutHandleDataService: this.withoutHandleDataService}, el: this})
    codeService.load()

    await this.watchCandidateComponent()
    this.$nextTick(() => {
      this.initComponent()
    })
    // 默认选中最后一个tab
    if (this.nodeTabEnable) {
      this.nodeTab.tempLastTabId = this.$_.cloneDeep(this.getHasComponentNode).pop() && this.$_.cloneDeep(this.getHasComponentNode).pop().id
      let getComponent = this.$_.cloneDeep(this.getComponent).reverse()
      // 找到最后一个不被隐藏的节点
      let component = getComponent.find(m => !m.properties.hidden)
      this.nodeTab.activeName = component ? component.id : ''
    }
    this.getCustomCommitHeight()
    this.$nextTick(() => {
      // 65th 当created 走完的时候loading 关闭
      this.formLoading = false
    })
  },
  methods: {
    getCustomCommitHeight () {
      Promise.resolve(sdk.components.ProcessCommit).then(() => {
        let shengrongCommit = document.getElementsByClassName('shengrong-comment')
        if (shengrongCommit.length) {
          this.customCommitHeight = shengrongCommit[0].clientHeight + 20
        }
      })
    },
    // 监听全部的候选人是控件中的值的控件，监听到控件值改变，就把改变的值赋值nodeAssigns，
    // 最后在提交的时候会吧符合的候选人nodeAssigns一起提交
    watchCandidateComponent () {
      let allNodeCandidate = []
      this.processDefinition.process.nodes.forEach(el => {
        if (el.type === 'userTask')allNodeCandidate.push(el)
      })
      allNodeCandidate.forEach(m => {
        this.$watch(() => {
          let listenObject = []
          m.candidates.forEach(n => {
            if (n.type === 'component') {
              // 选择的是控件,需要取dataService的值
              listenObject.push(this._provided.dataService.data[n.targetId])
            }
          })
          return listenObject
        }, _.debounce((newValue, oldValue) => {
          this.saveSelectComponent(m)
        }, 100))
      })
    },
    initComponent () {
      if (this.$refs.form) {
        this.$refs.form.find(m => m.component.id === this.currentNode.formId) && this.$refs.form.find(m => m.component.id === this.currentNode.formId).init()
        this.initStateObj.state = true
        this.initInteraction()
        // 分组展示必须在节点交互处理完控件的隐藏之后再做判断
        this.getProcessGroupNav()
        this.$nextTick(() => {
          this.eventBus.$emit('process.init', {component: this.processComponent})
        })
        // 加载完控件后滚动到最后一个节点处
        // 当前节点没有控件就不滚了
        let nodeComponent = this.processComponent.children.find(n => n.id === this.currentNode.formId)
        let childrens = nodeComponent.archivedChildren.filter(n => !n.properties.hidden)
        if (nodeComponent.archivedChildren.length && childrens.length) {
        // 加载完控件后滚动到最后一个节点处
          let top = 0
          this.$refs.form.forEach((m, index) => {
            if (index < this.$refs.form.length - 1) { top += m.$el.scrollHeight }
          })
          this.$nextTick(() => {
            this.$refs.formStyle.scrollTop = top
          })
        }
        if (this.page.starting) {
        // 只在发起节点(新流程)的时候对第一个表单聚焦操作
          this.$refs.form && this.$refs.form[0].firstInputFocus()
        }
      }
    },
    loadForm () {
      let request
      if (this.taskId) {
        request = this.$axios.get(`/process-api/runtime/data/${this.taskId}`)
      } else {
        this.page.starting = true
        request = this.$axios.get(`/process-api/runtime/loadProcessForm`, { params: { definitionId: this.hasDefinitionId } })
      }
      return new Promise(async resolve => {
        await request.then(res => {
        // 取出所有需要
          this.nodes = res.data.definition.process.nodes.filter(m => m.type === 'userTask')
          this.initStateObj.connections = res.data.definition.process.connections
          this.currentNodeId = res.data.currentNode
          this.currentNode = res.data.definition.process.nodes.find(m => m.id === res.data.currentNode)
          this.temporaryStorageEnable = res.data.definition.process.attribute.temporaryStorageEnable || false
          this.turnOnReassign = res.data.definition.turnOnReassign || false
          this.historyNodeIds = res.data.historyNode
          this.superiorComment = res.data.comment
          this.nodeCandidate = res.data.chooseCandidate
          this.groupNavDefinition = res.data.definition.groupNav
          this.processDefinition = ProcessDefinition.load(res.data.definition)
          this.bulidCandidate(res.data.chooseCandidate, res.data.runtimeAssignees)
          let component = FormComponent.load(res.data.component)
          this.nodeTabEnable = res.data.definition.nodeTabEnable
          this.customCommit = res.data.definition.process.attribute.customCommit
          this.processComponent = component
          // 找到来源控件使其必填开启
          res.data.chooseCandidate.forEach(m => {
            if (m.candidateRequired) {
              m.candidates.forEach(n => {
                if (n.type === 'component') {
                  let c = component.find(m => m.archive.columnId === n.targetId)
                  c.properties.required = true
                }
              })
            }
          })
          this.dataService.schema = res.data.schema
          if (res.data.data) {
            this.withoutHandleDataService = res.data.data
            this.countersignUsers = res.data.data
            let attribute = this.processDefinition.process.attribute
            if (attribute.allNodeArchiveEnable ||
          _.uniq(_.concat(res.data.historyNode, attribute.nodeArchive)).length !== res.data.historyNode.length + attribute.nodeArchive.length) {
            // 在当前节点之前, 如果存在数据, 并且数据已经归档, 数据重新构建(主要更改数据状态, 将后台的归档操作由 caret 改成 update 操作)
              this.dataService.data = this.dataService.buildModel(component.archive.tableId, res.data.data)
            } else {
            // 在当前节点之前, 如果存在数据, 并且数据没有归档, 则继续使用原有数据
              this.dataService.data = res.data.data
            }
          }
          this.starter = res.data.starter
          // 处理节点交互的数据
          if (this.processDefinition.process.attribute && this.processDefinition.process.attribute.nodeInteractions) {
            this.handleProcessNodeInteraction(this.processDefinition.process.attribute.nodeInteractions)
          }
          if (this.processDefinition.process.jsPath && this.processComponent.properties && this.processComponent.properties.functionsName) {
            let exts = document.createElement('script')
            exts.src = `${sessionStorage.getItem('ossDownloadUrl')}/${this.processDefinition.process.jsPath}`
            exts.id = this.processDefinition.process.jsPath
            document.body.appendChild(exts)
            exts.onload = () => {
              let redcatApp = window.redcatApp[this.processDefinition.id]
              if (redcatApp) {
                this.redcatApp = redcatApp
                // 调用脚本的load方法加载定制方法
                // 注意：因为使用call改变了当前this指向，所以在load方法中不能调用执行脚本中的其他方法
                this.redcatApp['load'] && this.redcatApp['load'].call(this, this)
                // 扩展当前对象属性
                this.bindApi(this.redcatApp)
                this.$nextTick(() => resolve())
              } else {
                resolve()
              }
            }
            exts.onerror = () => resolve()
          } else {
            resolve()
          }
        })
      })
    },
    buildData () {
      if (Object.keys(this.dataService.data).length <= 0) {
        let data = this.dataService.buildModel(this.processComponent.archive.tableId)
        this.dataService.data = data
      }
    },
    loadData (dataId) {
      return this.$axios.get(`/process-api/processes/${this.processDefinition.currentProcessId}/loadData?dataId=${dataId}`)
        .then(res => {
          this.dataService.data = this.dataService.buildModel(this.processComponent.archive.tableId, res.data)
        })
    },
    // 获取直属上级
    async getUserSuperior (userName = '') {
      return (await this.$axios.get(`/auth-api/users/currentUserSuperior`)).data
    },
    bulidCandidate (chooseCandidate, runtimeAssignees) {
      // 全部的节点候选人
      let allNodeCandidate = []
      this.processDefinition.process.nodes.forEach(el => {
        if (el.type === 'userTask')allNodeCandidate.push(el)
      })
      // 每个候选人是一个nodeAssign
      allNodeCandidate.forEach(n => {
        this.nodeAssigns.push({nodeId: n.id, targetId: '', name: ''})
      })
      // 如果有展示节点。则去找是否有处理人，有处理人就赋值给nodeAssign
      chooseCandidate.forEach(m => {
        let candidate = m.candidates.find(m => m.defaultValue === true)
        let assign = this.nodeAssigns.find(n => n.nodeId === m.id)
        // 如果是直属上级，而且只有一个人的时候，默认选中该人
        if (m.candidates[0].type === 'superiors') {
          if (this.candidateIsSuperiors.allPeople.length === 1) {
            assign.targetId = this.candidateIsSuperiors.allPeople[0].id
            assign.name = this.candidateIsSuperiors.allPeople[0].name
            this.$set(this.candidatesColor, m.name, 'black')
          }
        } else {
          // 如果不是直属上级，判断候选人如果是一个人的时候，默认也选中
          if (m.candidates.length === 1 && m.candidates[0].type !== 'department' && m.candidates[0].type !== 'group') {
            assign.targetId = m.candidates[0].targetId
            assign.name = m.candidates[0].name
            this.$set(this.candidatesColor, m.name, 'black')
          }
        }
        if (m.isCountersign) {
          let currentNodeIdAssignsess = []
          runtimeAssignees.filter(n => n.nodeId === m.id).forEach(m => {
            if (!currentNodeIdAssignsess.find(n => n.executorName === m.executorName && n.executorId === m.executorId)) {
              currentNodeIdAssignsess.push(m)
            }
          })
          if (currentNodeIdAssignsess.length) {
            candidate = {
              'targetId': currentNodeIdAssignsess.map(n => n.executorId).join(','),
              'name': currentNodeIdAssignsess.map(n => n.executorName).join(',')
            }
            assign.targetId = candidate.targetId || ''
            assign.name = candidate.name || ''
          }
        } else {
          let currentNodeIdAssignees = runtimeAssignees.filter(n => n.nodeId === m.id)

          if (currentNodeIdAssignees && currentNodeIdAssignees.length === 1) {
            candidate = {'targetId': currentNodeIdAssignees[0].executorId, 'name': currentNodeIdAssignees[0].executorName}
          } else if (currentNodeIdAssignees && currentNodeIdAssignees.length > 1) {
            candidate = {}
            candidate.targetId = currentNodeIdAssignees.map(o => o.executorId).join(',')
            candidate.name = currentNodeIdAssignees.map(o => o.executorName).join(',')
          }
          if (candidate) {
            assign.targetId = candidate.targetId || ''
            assign.name = candidate.name || ''
          }
        }
      })
    },
    getShowAssigns (nodeId) {
      return this.nodeAssigns.find(m => m.nodeId === nodeId)
    },
    // 定制暂存
    beforeTemporaryStorage ({params}) {
      return this.eventBus.$emit('process.beforeTemporaryStorage', {data: params, currentNode: this.currentNode})
    },
    async temporaryStorage () {
      let nodeExecutor = {}
      let variables = this.dataService.data
      this.nodeAssigns.forEach(m => {
        if (m.targetId) {
          let node = this.nodes.find(n => n.id === m.nodeId)
          if (node && node.isCountersign) {
            // 存放会签人员的信息，后端说这么放
            let countersignUsers = []
            // 如果是会签节点，候选人是多选形式
            let candidates = []
            let names = m.name.split(',')
            m.targetId.split(',').forEach((el, index) => {
              candidates.push(`${el}$${names[index]}`)
              countersignUsers.push(`${el}`)
            })

            let editNodeId = m.nodeId.replace(/-/g, '')
            let countersignUser = `countersignUsers${editNodeId}`
            // 如果当前节点是会签节点的展示节点，则不取接口返回回来会签候选人的值，取展示节点选的人
            if (!this.nodeCandidate.find(el => el.id === m.nodeId) && this.countersignUsers[countersignUser] && this.countersignUsers[countersignUser].length) {
              countersignUsers = this.countersignUsers[countersignUser]
            }
            nodeExecutor[m.nodeId] = candidates
            variables[countersignUser] = countersignUsers
          } else {
            // 来源控件多候选人情况
            let candidates = []
            if (m.targetId.split(',').length >= 2) {
              let names = m.name.split(',')
              m.targetId.split(',').forEach((el, index) => {
                candidates.push(`${el}$${names[index]}`)
              })
              nodeExecutor[m.nodeId] = candidates
            } else {
              nodeExecutor[m.nodeId] = `${m.targetId}$${m.name}`
            }
          }
        }
      })
      //  开始暂存
      this.staging = true
      this.$refs.staging.$el.disabled = true
      // 如果是新流程实例， 则先发起流程， 再执行暂存
      if (this.page.starting) {
        this.taskId = await this.startingProcess(this.hasDefinitionId)
      }

      let params = {
        'taskId': this.taskId,
        nodeExecutor,
        variables
      }
      await this.beforeTemporaryStorage({params})
      //  55期优化发起节点暂存bug。判断是否为发起节点，如果是发起节点 且不是 返回回来的发起节点 ,改为create
      if (this.processDefinition.process.startNode === this.currentNodeId && this.historyNodeIds.length === 0) {
        //  说明是发起节点
        params.variables.dataState = params.variables.dataState === 'update' ? 'create' : params.variables.dataState
      }
      await this.$axios.post(`/process-api/runtime/stagingTask`, params).then((res) => {
        this.staging = false
        this.$refs.staging.$el.disabled = false
        if (res.status === 200) {
          this.page.starting = false
          this.$message({
            message: '暂存成功！',
            type: 'success',
            customClass: 'temporaryStorageTip',
            center: true
          })
        }
      })
    },
    // 控件校验
    componentValidate () {
      if (!this.$refs.form || !this.$refs.form.find(m => m.disable === false)) {
        return Promise.resolve()
      } else {
        return this.$refs.form.find(m => m.disable === false).validate()
      }
    },
    // 操作校验
    async formOperationValidate (formValidates) {
      if (formValidates) {
        await Promise.all(formValidates.map(this.singleFormValidate))
      } else {
        return Promise.resolve()
      }
    },
    findJuheColumns (text, result) {
      let juhefunc = ['sum', 'max', 'average', 'count', 'min', 'group_concat', 'sumif', 'averageif', 'averageif', 'simple', 'large', 'small', 'median']
      let func = 'wu'
      for (let i = 0; i < juhefunc.length; i++) {
        if (text.toLowerCase().indexOf(juhefunc[i]) !== -1) {
          func = juhefunc[i]
          break
        }
      }
      let postion = text.toLowerCase().indexOf(func)
      if (postion === -1) {
        return result
      } else {
        let char = ''
        const stacks = []
        let newtext = text.slice(postion)
        let index = 0
        for (let i = 0; i < newtext.length; i++) {
          char = newtext[i]
          if (char === ')') {
            stacks.push(char)
            let str = stacks.join('')
            if (str.split('(').length === str.split(')').length) {
              index = i
              break
            }
          } else {
            stacks.push(char)
          }
        }

        result.push(stacks.join(''))
        return this.findJuheColumns(text.slice(postion + index), result)
      }
    },
    singleFormValidate (el) {
      return new Promise(async (resolve, reject) => {
        // 1.不考虑跨表
        // 2.不考虑 聚合某列 又单选某列
        let valueArr = this.getColumnIds(el.expression)
        // 找到被聚合函数包裹的字段
        let JuheColumns = this.findJuheColumns(el.expression, [])
        valueArr.forEach(m => {
          m.juhe = false
          if (JuheColumns.some(n => n.includes(m.columnId))) {
            m.juhe = true
          }
        })
        // 校验是否有子表格数据
        let isChild = valueArr.some(a => a.relationId && this.dataService.data[a.relationId])
        if (isChild) {
          let length = 1

          let hasNotJuheColumn = valueArr.some(a => a.relationId && this.dataService.data[a.relationId] && !a.juhe)
          // 有一个表格内的字段不是聚合就需要遍历 拿到表格行数
          if (hasNotJuheColumn) {
            valueArr.map(m => {
              if (m.relationId) {
                length = this.dataService.data[m.relationId].length
              }
            })
          }
          el.expressionResult = []
          for (let i = 0; i < length; i++) {
            let obj1 = {}
            valueArr.map(async m => {
              if (m.relationId && this.dataService.data[m.relationId] && m.juhe) {
                let prame = []
                this.dataService.data[m.relationId].forEach(el => {
                  if (el[m.columnId] !== '' && typeof (m.columnId) !== 'undefined' && el[m.columnId] !== null) {
                    prame.push(el[m.columnId])
                  }
                })
                if (prame.length > 0) {
                  obj1[m.columnId] = prame
                }
              } else if (m.relationId && this.dataService.data[m.relationId] && !m.juhe) {
                let o = this.dataService.data[m.relationId][i]
                if (o[m.columnId] !== '' && typeof (m.columnId) !== 'undefined' && o[m.columnId] !== null) {
                  obj1[m.columnId] = o[m.columnId]
                }
              } else {
                obj1[m.columnId] = this.dataService.data[m.columnId]
              }
            })
            await this.$axios.post('/form-api/runtime/calc', {'formula': el.expression, 'variables': obj1})
              .then(res => {
                el.expressionResult.push(res.data)
              })
          }
          resolve()
        } else {
          let obj = {}
          valueArr.forEach(m => {
            if (m.relationId) {
              let prame = []
              this.dataService.data[m.relationId].forEach(el => {
                if (el[m.columnId] !== '' && typeof (m.columnId) !== 'undefined' && el[m.columnId] !== null) {
                  prame.push(el[m.columnId])
                }
              })
              if (prame.length > 0) {
                obj[m.columnId] = prame
              }
            } else {
              obj[m.columnId] = this.dataService.data[m.columnId]
            }
          })
          this.$axios.post('/form-api/runtime/calc', {'formula': el.expression, 'variables': obj})
            .then(res => {
              el.expressionResult = [res.data]
              resolve()
            })
        }
      })
    },
    async formValidateTip (formValidates) {
      if (formValidates) {
        for (let i = 0; i < formValidates.length; i++) {
          for (let j = 0; j < formValidates[i].expressionResult.length; j++) {
            await this.checkOperationResult(formValidates[i], formValidates[i].expressionResult[j])
          }
        }
      } else {
        return Promise.resolve()
      }
    },
    checkOperationResult (m, expressionResult) {
      return new Promise((resolve, reject) => {
        if (expressionResult) {
          switch (m.promptType) {
            case 'withoutExecute':
              this.withoutExecuteDialog(m, () => {
                reject(new Error('条件不满足'))
              })
              break
            case 'isExecute':
              this.isExecuteDialog(m, (data) => {
                if (!data) {
                  reject(new Error('条件不满足'))
                } else {
                  resolve()
                }
              })
              break
            case 'withExecute':
              this.withExecuteDialog(m, () => resolve())
              break
            default:
              reject(new Error('未知的错误'))
          }
        } else {
          resolve()
        }
      })
    },
    // 提示且不执行弹窗
    withoutExecuteDialog (operationVilidate, callback) {
      return new Promise((resolve) => {
        this.$message({
          message: operationVilidate.tip,
          center: true,
          duration: 3000,
          customClass: 'without-execute-dialog'
        })
        resolve()
      }).then(() => {
        callback()
      })
    },
    isExecuteDialog (operationVilidate, callback) {
      this.$confirm('', operationVilidate.tip, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'publishMessageBox',
        center: true
      }).then(() => {
        let data = true
        callback(data)
      }).catch(() => {
        let data = false
        callback(data)
      })
    },
    // 提示且执行弹窗
    withExecuteDialog (operationVilidate, callback) {
      this.$alert(operationVilidate.tip, '', {
        confirmButtonText: '确定',
        center: true,
        callback: action => {
          callback()
        }
      })
    },
    // 候选人校验
    candidateValidate () {
      return new Promise((resolve, reject) => {
        let requiredCandidate = []
        this.nodeCandidate.forEach(m => {
          if (m.candidateRequired) {
            requiredCandidate.push({'nodeId': m.id, 'nodeName': m.name})
          }
        })
        let nodeExecutor = {}
        this.nodeAssigns.forEach(m => {
          if (m.targetId) {
            let node = this.nodes.find(n => n.id === m.nodeId)
            if (node && node.isCountersign) {
              // 如果是会签节点，候选人是多选形式
              let candidates = []
              let names = m.name.split(',')
              m.targetId.split(',').forEach((el, index) => {
                candidates.push(`${el}$${names[index]}`)
              })
              nodeExecutor[m.nodeId] = candidates
            } else {
              // 来源控件多候选人情况
              let candidates = []
              if (m.targetId.split(',').length >= 2) {
                let names = m.name.split(',')
                m.targetId.split(',').forEach((el, index) => {
                  candidates.push(`${el}$${names[index]}`)
                })
                nodeExecutor[m.nodeId] = candidates
              } else {
                nodeExecutor[m.nodeId] = `${m.targetId}$${m.name}`
              }
            }
          }
        })
        let errorCandidate = requiredCandidate.find(m => !nodeExecutor.hasOwnProperty(m.nodeId))
        if (errorCandidate) {
          this.$message.error(`${errorCandidate.nodeName}候选人必填`)
          reject(new Error(`${errorCandidate.nodeName}候选人必填`))
        }
        // 审批人和流程申请人不能相同，请修改
        let starter = this.processDefinition.process.startNode === this.currentNodeId ? sessionStorage.getItem('userId') : this.starter
        for (let i = 0; i < this.nodeCandidate.length; i++) {
          let currentNodeAssign = this.nodeAssigns.find(n => n.nodeId === this.nodeCandidate[i].id)
          if (this.nodeCandidate[i].canSameAsStarter && currentNodeAssign.targetId) {
            if (currentNodeAssign.targetId === starter) {
              this.$message.error(`${this.nodeCandidate[i].name}审批人和流程申请人不能相同，请修改`)
              currentNodeAssign.targetId = ''
              currentNodeAssign.name = ''
              reject(new Error(`${this.nodeCandidate[i].name}审批人和流程申请人不能相同，请修改`))
            }
          }
        }

        resolve()
      })
    },
    isNormalButton (actionId, type) {
      let length = 0
      let hasbuttonsConnetions = this.processDefinition.process.connections.filter(n => n.actionId === actionId)
      let currentAction = this.currentNode.actions.find(item => item.id === actionId)
      if (currentAction.name === '不通过' || currentAction.name === '不同意') {
        length = 0
      } else if (hasbuttonsConnetions.length) {
        let hasNormalButtons = hasbuttonsConnetions.filter(n => n.operationType === 'normal' || n.operationType === 'endEvent')
        length = hasNormalButtons.length
      } else if (type === '1') {
        let defaultConnetion = this.processDefinition.process.connections.find(n => n.sourceNodeId === this.currentNode.id && n.defaultLine === true)
        if (defaultConnetion) {
          if (defaultConnetion.operationType === 'normal' || defaultConnetion.operationType === 'endEvent') {
            length = 1
          }
        }
      }
      return length
    },
    commentFormValidate (actionId) {
      let commentRequiredNode = this.currentNode.actions.find(item => item.id === actionId)
      if (commentRequiredNode.requiredRequired) {
        return this.$refs['commentForm'].validate()
      } else {
        return this.$refs['commentForm'].clearValidate()
      }
    },
    // 处理某个节点展示节点为空，候选人为1位候选人的情况，直接将一位候选人作为处理人
    handleOnePeople (actionId) {
      // 没有展示节点
      // 通过按钮找到符合的流转线
      return new Promise((resolve, reject) => {
        if (!this.nodeCandidate.length) {
          let hasbuttonsConnetions = this.processDefinition.process.connections.filter(n => n.actionId === actionId)
          if (hasbuttonsConnetions.length > 0) {
          // 找到是正常的流转线
            let hasNormalButtons = hasbuttonsConnetions.filter(n => n.operationType === 'normal' || n.operationType === 'endEvent')
            hasNormalButtons.forEach(m => {
              let node = this.processDefinition.process.nodes.find(n => n.id === m.targetNodeId)
              // 如果下一个节点是会签节点并且之前没有选过人员
              let nodeId = node.id.replace(/-/g, '')
              let countersignUser = `countersignUsers${nodeId}`
              if (node.isCountersign && (!this.countersignUsers[countersignUser] || !this.countersignUsers[countersignUser].length)) {
                let nodeAssign = this.nodeAssigns.find(m => m.nodeId === node.id)
                if (nodeAssign) {
                  let ids = []
                  let persons = []
                  node.candidates.forEach(m => {
                    ids.push({'id': m.targetId, 'type': m.type})
                  })
                  this.$axios.post('/auth-api/departments/departmentMemberTreeById', ids).then((res) => {
                    if (res.data.length) {
                      persons = this.recursionCandidates(res.data, [])
                      nodeAssign.targetId = persons.map(n => n.id).join(',')
                      nodeAssign.name = persons.map(n => n.name).join(',')
                      resolve()
                    }
                  })
                }
              } else {
              // 下一个节点候选人只有一个而且是自定义类型的
                if (node.candidates.length === 1 && node.candidates[0].type === 'user') {
                  this.nodeAssigns.push({'nodeId': node.id, 'targetId': node.candidates[0].targetId || '', 'name': node.candidates[0].name || ''})
                  resolve()
                } else {
                  resolve()
                }
              }
            })
          } else {
            resolve()
          }
        } else {
          resolve()
        }
      })
    },
    // 递归查找全部的人
    recursionCandidates (people, candidates) {
      people.forEach(m => {
        if (m.type === 'user') {
          candidates.push(m)
        } else {
          this.recursionCandidates(m.children, candidates)
        }
      })
      return candidates
    },
    buttonClick (actionId, actionName, action) {
      // 节点是tab的时候、提交数据的时候为最后一个tab
      this.nodeTab.activeName = this.nodeTab.tempLastTabId
      // 如果是打印，则直接走打印接口，不触发任何操作
      if (action.type === '打印') {
        return this.printTemplate(action)
      }
      this.loading.activeLoadingId = actionId
      this.loading.isloading = true
      let formValidates = this.processComponent.formValidates && this.processComponent.formValidates.filter(n => n.nodeId === this.currentNode.id && n.enable)
      formValidates = formValidates || []
      this.buttonState(true)
      this.$nextTick(() => {
        if (this.isNormalButton(actionId, '1')) {
          // 意见增加必填
          AsyncRequest.validRequest()
            .then(this.addValidate(actionId))
            .then(() => this.componentValidate())
            .then(() => {
              // 特殊处理表格数据
              this.dataService.buildSubmitData(this.processComponent)
              return this.formOperationValidate(formValidates)
            })
            .then(() => this.formValidateTip(formValidates))
            .then(() => this.commentFormValidate(actionId))
            .then(() => this.handleOnePeople(actionId))
            .then(() => this.candidateValidate())
            .then(() => this.submit(actionId, actionName))
            .then(async () => {
              this.loading.isloading = false
              this.$emit('closeDialog', 'process')
              await this.executeFunctions(actionId, 'afterSubmit')
            }).catch(() => {
              this.$nextTick(() => {
                this.loading.isloading = false
                let isError = document.querySelectorAll('.is-error')
                if (isError && isError.length !== 0) {
                  if (isError[0].querySelector('input')) {
                    isError[0].querySelector('input').focus()
                  } else if (isError[0].querySelector('textarea')) {
                    isError[0].querySelector('textarea').focus()
                  } else if (isError[0].querySelector('.selected')) {
                    this.$refs.formStyle.scrollTop = isError[0].parentElement.parentElement.getBoundingClientRect().top + this.$refs.formStyle.scrollTop
                  }
                }
              })
              this.buttonState(false)
            })
        } else {
          AsyncRequest.validRequest()
            .then(this.addValidate(actionId))
            .then(() => this.commentFormValidate(actionId))
            .then(() => this.submit(actionId, actionName))
            .then(async () => {
              this.loading.isloading = false
              this.$emit('closeDialog', 'process')
              await this.executeFunctions(actionId, 'afterSubmit')
            }).catch(() => {
              this.loading.isloading = false
              this.buttonState(false)
            })
        }
      })
    },
    // 按钮是否禁用
    buttonState (state) {
      this.$refs.buttons.forEach(m => { m.$el.disabled = state })
    },
    // 意见校验添加到按钮上
    addValidate (actionId) {
      return new Promise((resolve, reject) => {
        let myActions = this.currentNode.actions.find(item => item.id === actionId)
        if (myActions.requiredRequired) {
          this.commentRequired = true
          this.getRule.required = true
        } else {
          this.getRule.required = false
        }
        resolve()
      })
    },
    submit (actionId, actionName) {
      return new Promise(async (resolve, reject) => {
        let nodeExecutor = {}
        let variables = this.dataService.data
        this.nodeAssigns.forEach(m => {
          if (m.targetId) {
            let node = this.nodes.find(n => n.id === m.nodeId)
            if (node && node.isCountersign) {
              // 存放会签人员的信息，后端说这么放
              let countersignUsers = []
              // 如果是会签节点，候选人是多选形式
              let candidates = []
              let names = m.name.split(',')
              m.targetId.split(',').forEach((el, index) => {
                candidates.push(`${el}$${names[index]}`)
                countersignUsers.push(`${el}`)
              })

              let editNodeId = m.nodeId.replace(/-/g, '')
              let countersignUser = `countersignUsers${editNodeId}`
              // 如果当前节点是会签节点的展示节点，则不取接口返回回来会签候选人的值，取展示节点选的人
              if (!this.nodeCandidate.find(el => el.id === m.nodeId) && this.countersignUsers[countersignUser] && this.countersignUsers[countersignUser].length) {
                countersignUsers = this.countersignUsers[countersignUser]
              }
              nodeExecutor[m.nodeId] = candidates
              variables[countersignUser] = countersignUsers
            } else {
              // 来源控件多候选人情况
              let candidates = []
              if (m.targetId.split(',').length >= 2) {
                let names = m.name.split(',')
                m.targetId.split(',').forEach((el, index) => {
                  candidates.push(`${el}$${names[index]}`)
                })
                nodeExecutor[m.nodeId] = candidates
              } else {
                nodeExecutor[m.nodeId] = `${m.targetId}$${m.name}`
              }
            }
          }
        })
        let params = {
          'taskId': this.taskId,
          'actionId': actionId,
          'comment': this.commentForm.approvalComment,
          actionName,
          nodeExecutor,
          variables
        }
        // 如果是新流程实例， 则先发起流程， 再执行流转
        if (this.page.starting) {
          try {
            // 在流程实例创建之前触发
            await this.beforeStartingProcess({params})
            // 触发流程提交前事件，如果是发起节点应该在流程实例创建之前触发
            await this.executeFunctions(actionId, 'beforeSubmit')
            this.taskId = await this.startingProcess(this.hasDefinitionId)
          } catch (error) {
            return reject(error)
          }
        }
        params.taskId = this.taskId
        try {
          await this.beforeSubmit({params})
          // 因为流程实例创建之前上面已经触发了一次了
          if (!this.page.starting) {
            await this.executeFunctions(actionId, 'beforeSubmit')
          }
          //  55期优化发起节点暂存bug。判断是否为发起节点，如果是发起节点 且不是 返回回来的发起节点,并且初始是dataStateInit create ,改为create
          if (this.processDefinition.process.startNode === this.currentNodeId && this.historyNodeIds.length === 0 && params.variables.dataStateInit === 'create') {
            //  说明是发起节点 主表处理
            params.variables.dataState = params.variables.dataState === 'update' ? 'create' : params.variables.dataState
            // 子表处理
            for (let key in params.variables) {
              if (params.variables[key] instanceof Array) {
                params.variables[key].forEach(el => {
                  el.dataState = el.dataState === 'update' ? 'create' : el.dataState
                })
              }
            }
          }
          await this.$axios.post(`/process-api/runtime/completeTask`, params)
          await this.afterSubmit({params})
          // 需要判断当前流程的流程标题是否引控件。如果引用则还需要走一个更新接口。
          let component = this.processComponent.allChildren.filter(n => n instanceof ColumnComponent)
          if (component.length && component.map(el => el.archive.columnId).some((a) => this.processDefinition.process.attribute.processTitle.includes(a))) {
            await this.$axios.get(`/process-api/runtime/updateProcessTitle?taskId=${this.taskId}&dataId=${params.variables.id}`)
          }
        } catch (error) {
          reject(error)
        }
        resolve()
      })
    },
    async startingProcess (definitionId) {
      const res = await this.$axios.post('/process-api/runtime/startProcess', {definitionId})
      return res.data
    },
    beforeSubmit ({params}) {
      return this.eventBus.$emit('process.beforeSubmit', {params, currentNode: this.currentNode})
    },
    afterSubmit ({params}) {
      return this.eventBus.$emit('process.afterSubmit', {params, currentNode: this.currentNode})
    },
    beforeStartingProcess ({params}) {
      return this.eventBus.$emit('process.beforeStartingProcess', {params, currentNode: this.currentNode})
    },
    open () {
      this.$nextTick(() => {
        this.$refs.select.init()
      })
    },
    cancel () {
      this.selectPeople.dialogVisible = false
      this.nodeAssign = ''
      this.currentSelectPersonNodeId = ''
    },
    selectPerson (nodeId) {
      this.currentSelectPersonNodeId = nodeId
      let node = this.nodes.find(m => m.id === nodeId)
      this.nodeAssign = this.nodeAssigns.find(m => m.nodeId === nodeId).targetId
      if (node.candidates[0].type === 'superiors') {
        // 直属上级点击不打开候选人tree弹窗
        if (this.candidateIsSuperiors.allPeople && this.candidateIsSuperiors.allPeople.length === 1) {
          this.candidateIsSuperiors.visible = false
        } else {
          this.candidateIsSuperiors.visible = true
        }
        this.candidateIsSuperiors.data = this.getSelectPersons
      } else {
        let ids = []
        node.candidates.forEach(m => {
          ids.push({'id': m.targetId, 'type': m.type})
        })
        this.selectPeople.nodeId = nodeId
        // 判断只有是候选人为多人时点击，发送请求打开候选人tree弹窗
        if (node.candidates.length > 1 || node.candidates[0].type === 'department' || node.candidates[0].type === 'group') {
          this.$axios.post('/auth-api/departments/departmentMemberTreeById', ids).then((res) => {
            this.allData = res.data
            this.selectPeople.dialogVisible = true
          })
        }
      }
    },
    getIsCountersign (nodeId) {
      let node = this.nodes.find(m => m.id === nodeId)
      return node.isCountersign
    },
    saveSelectPerson () {
      let persons = this.$refs.select.getSelectedList()
      let assign = this.nodeAssigns.find(m => m.nodeId === this.currentSelectPersonNodeId)
      if (persons && persons.length !== 0) {
        if (persons.length === 1) {
          assign.targetId = persons[0].id
          assign.name = persons[0].name
        } else {
          // 会签候选人有多个，特殊处理
          assign.targetId = persons.map(n => n.id).join(',')
          assign.name = persons.map(n => n.name).join(',')
        }
      } else {
        assign.targetId = ''
        assign.name = ''
      }
      this.cancel()
    },
    saveSelectComponent (node) {
      let assign = this.nodeAssigns.find(m => m.nodeId === node.id)
      if (assign) {
        assign.targetId = this._provided.dataService.data[node.candidates[0].targetId].replace(/\s/g, '')
        if (assign.targetId) {
          this.$axios.get(`/process-api/runtime/getUser/${assign.targetId}`).then((data) => {
            assign.name = data.data.map((el) => el.name).join(',')
          })
        }
      }
    },
    moreComment () {
      cache.getData(`/process-api/runtime/dealRecord?taskId=${this.taskId}`).then((data) => {
        this.approvalCommentHistory = data
        this.commentVisible = true
      })
    },
    // 打印
    printTemplate (action) {
      let params = {
        templateId: action.templateName,
        params: this.dataService.data,
        type: 'process',
        definitionId: this.processDefinition.id
      }
      let tableId = this.dataService.schema.tables[0].id
      this.getField({tableId: tableId, dataId: params.params.id}).then(res => {
        let obj = {...params.params}
        params.params = _.merge({...obj}, {...res})
        this.$axios.post('/system-api/printTemplate/printTemplate', params).then(res => {
          window.open(`${this.viewUrl}${res.data.result.dir}`)
        })
      })
    },
    // 获取审计字段
    getField (params) {
      return new Promise(resolve => {
        this.$axios.get('/data-api/data/loadData', {params}).then(res => {
          resolve(Object.keys(res.data).length === 0 ? {} : res.data[params.tableId][0])
        })
      })
    },
    openTurnOnReassign () {
      this.turnOnReassignDialog.dialogVisible = true
    },
    openDialog () {
      this.selectInformDialog.visable = true
      this.selectInformDialog.data = this.turnOnReassignDialog.candidate
    },
    getCandidate (data) {
      this.turnOnReassignDialog.candidate = data
      this.selectInformDialog.visable = false
      this.$refs.turnForm.validateField('candidate')
    },
    confirmTurnon () {
      this.$refs.turnForm.validate((valid) => {
        if (valid) {
          let params = {
            userId: this.turnOnReassignDialog.candidate[0].id,
            userName: this.turnOnReassignDialog.candidate[0].name,
            explain: this.turnOnReassignDialog.explain,
            instanceId: this.instanceId,
            nodeId: this.currentNodeId,
            taskId: this.taskId,
            processName: this.processDefinition.name,
            startName: this.started,
            startTime: this.startedTime
          }
          this.$axios.post('/process-api/runtime/reassignTask', params).then(res => {
            this.$emit('closeDialog', 'process')
          })
        }
      })
    },
    // 给当前的redcatApp对象绑定
    bindApi (redcatApp) {
      redcatApp.$el = this
      redcatApp.$UUID = UUID
    },
    getRedcatApp () {
      return this.redcatApp
    },
    /*
    * 执行页面js的方法
    * @param type {string} 需要执行的方法类型
    * */
    executeFunctions (actionId, type) {
      let button = this.currentNode.actions.find(c => c.id === actionId) || {}
      if (button.jsActions) {
        let actions = JSON.parse(button.jsActions)
        actions && actions.length && actions.forEach(async action => {
          if (action.type === type) {
            await this.redcatApp[action.function](this)
          }
        })
      }
    },
    getCandidatesuperiors (candidateIsSuperior) {
      let assign = this.nodeAssigns.find(m => m.nodeId === this.currentSelectPersonNodeId)
      if (candidateIsSuperior && candidateIsSuperior.length !== 0) {
        assign.targetId = candidateIsSuperior[0].id
        assign.name = candidateIsSuperior[0].name
      } else {
        assign.targetId = ''
        assign.name = ''
      }
      this.nodeAssign = ''
      this.currentSelectPersonNodeId = ''
      this.candidateIsSuperiors.visible = false
    },
    gatewayNodes () {
      this.$axios.get(`/process-api/runtime/gatewayNodes/${this.taskId}`).then(res => {
        this.inclusiveGatewayNode.isInGateway = res.data.isInGateway
        this.inclusiveGatewayNode.gatewayNodeIds = res.data.gatewayNodeIds
        // 处理并行网关的数据
        // 66th 归档清空的节点中去掉网关内的历史节点
        this.inclusiveGatewayNode.gatewayNodeIds.forEach((item, index) => {
          if (this.historyNodeIds.includes(item)) {
            this.inclusiveGatewayNode.gatewayNodeIds.splice(index, 1)
          }
        })
        this.inclusiveGatewayNode.gatewayNodeIds.forEach(m => {
          let node = this.nodes.find(n => n.id === m)
          if (node) {
            let component = this.processComponent.children.find(n => n.id === node.formId)
            component.allChildren.forEach(a => {
              if (a instanceof TableComponent) {
                delete this.dataService.data[a.archive.relationId]
              } else {
                delete this.dataService.data[a.archive.columnId]
              }
            })
          }
        })
      })
    }
  },
  computed: {
    getSelectPersons () {
      let selectPersons = []
      let assign = this.nodeAssigns.find(m => m.targetId === this.nodeAssign)
      if (assign) {
        let node = this.nodes.find(m => m.id === assign.nodeId)
        if (node.isCountersign || assign.targetId.split(',').length > 1) {
          assign.targetId.split(',').forEach((people, index) => {
            selectPersons.push({'targetId': people, 'name': assign.name.split(',')[index]})
          })
        } else {
          selectPersons.push({'targetId': assign.targetId, 'name': assign.name})
        }
      }
      return selectPersons
    },
    getHasComponentNode () {
      let components = []
      // 放入历史节点的表单
      this.historyNodeIds.forEach(m => {
        let node = this.nodes.find(n => n.id === m)
        if (node) {
          let component = this.processComponent.children.find(n => n.id === node.formId)
          component.history = true
          this.hiddenForm(component) && components.push(component)
        }
      })
      // 放入当前节点的表单
      if (this.processComponent.children) {
        let component = this.processComponent.children.find(n => n.id === this.currentNode.formId)
        component.history = false
        this.hiddenForm(component) && components.push(component)
      }
      return components
    },
    getComponent () {
      let components = []
      // 放入历史节点的表单
      this.historyNodeIds.forEach(m => {
        let node = this.nodes.find(n => n.id === m)
        if (node) {
          let component = this.processComponent.children.find(n => n.id === node.formId)
          component.history = true
          components.push(component)
        }
      })
      // 放入当前节点的表单
      if (this.processComponent.children) {
        let component = this.processComponent.children.find(n => n.id === this.currentNode.formId)
        component.history = false
        components.push(component)
      }
      // 处理节点交互要隐藏的表单
      components = this.updateFormNodeInteractions(components, this.currentNodeId)
      return components
    },
    formHeight () {
      let height = 32
      // 上级审批意见的高度
      if (this.superiorComment || this.historyNodeIds.length !== 0 || !this.hasDefinitionId) {
        height += 34
      }
      // 候选人的高度
      if (this.nodeCandidate && this.nodeCandidate.length) {
        height += 30
      }
      if (this.currentNode.approvalOpinion) {
        height += 60
      }
      // 晟融意见的高度
      if (this.customCommitHeight) {
        height += this.customCommitHeight
      }
      return `calc(100% - ${height}px)`
    }
  },
  mounted () {
    this.customWatchRef(this.$refs.formStyle)
  }
}
</script>

<style lang="scss">
.process-runtime {
  width: 100%;
  height: 100%;
  background: #fff;
  box-shadow: 4px 4px 4px rgba(174, 222, 251, 0.1);
  .el-loading-mask {
    .el-loading-spinner {
      top:40%;
      .el-loading-text {
        color: #333333;
      }
    }
  }
  > div.main {
    width: 100%;
    height: 100%;
    padding: 20px 20px 30px 20px;
    > div.form {
      width: 100%;
    }
    .form {
      position: relative;
      margin-bottom: 10px;
      .node-tab {
        height: 100%;
        .el-tabs__content {
          overflow: auto;
          height: calc(100% - 44px);
        }
        .el-tabs__item  {
          height: 28px;
          line-height: 28px;
          width: 112px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          display: inline-block;
        }
      }
      .process-group-nav{
        position: fixed;
        width: 110px;
        height: calc(100% - 270px);
        overflow-y: scroll;
        .el-tabs__header.is-left{
          width: 100px;
          .el-tabs__item{
            display: flex;
            align-items: center;
            height: 50px;
            padding-left: 0;
            padding-right: 10px;
            span{
              display: inline-block;
              width: 100%;
              height: 28px;
              line-height: 14px;
              overflow: hidden;
              text-align: right;
              white-space: pre-line;
              text-overflow: ellipsis;
            }
          }
        }
        .el-tabs__content{
          display: none;
        }
        @media (min-width: 1366px){
          width: 134px;
          .el-tabs__header.is-left{
            width: 124px;
          }
        }
      }
      .process-group-nav-form{
        margin-left: 124px;
        @media (min-width: 1366px){
          margin-left: 134px;
        }
      }
     .box1 {
        height: 100%;
      }
    }
    .comment {
      padding-left: 24px;
      .el-form {
        .el-form-item__label {
          font-size: 12px;
          color: #181818;
        }
        .superior-comment {
          margin-bottom: 10px;
        }
        .comment-content {
          width: 700px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          text-align: left;
        }
        .more {
          float: right;
          cursor: pointer;
        }
      }
      .more {
        float: right;
        cursor: pointer;
      }
    }
    .shengrong-comment {
      margin-bottom: 20px;
    }
  }
  .candidate-button{
    padding-left: 24px;
    .candidate {
      height: 30px;
      vertical-align: top;
      > label {
        padding-right: 10px;
        > label {
          padding-left: 5px;
            color: var(--primary, #54ABF1);
            cursor: pointer;
          }
        }
      }
    .button {
      .el-row {
        text-align: center;
         .el-button--mini {
            padding: 5px 9px;
           &.read-button{
             border: 1px solid var(--primary, #52ACF1);
             color: var(--primary, #52ACF1);
           }
           &:focus{
             border-color:var(--primary, #2355a7);
           }
         }
    }
    }
  }
}

.el-message.el-message--info.is-center.without-execute-dialog{
    position: fixed;
    left: calc(50% + 100px);
    top: 40%;
    background-color: #29282E;
    >p{
      color: #FFFFFF;
    }
    >i{
      display: none;
    }
  }
.saveLoading {
  .el-loading-spinner {
    width: 260px;
    height: 70px;
    background: #fff;
    margin-left: -130px;
    left: 50%;
    border-radius: 5px;
    padding-top: 20px;

    .el-loading-text {
      display: inline-block;
      color: #606266
    }

    .el-icon-loading {
      position: absolute;
      right: 56px;
      color: #606266;
      top: 25px;
    }
  }
}
.process-select-person-dialog{
  .el-dialog{
    width: 646px;
    .el-dialog__body {
      .dialog-buttons {
        text-align: center;
        padding-top: 50px;
        padding-top: 30px;
      }
    }
  }

}
.el-message.temporaryStorageTip {
    top: 20% !important;
    z-index: 2001;
    min-width: 176px;
    padding: 15px 38px;
    left: 55%;
}
.turnon-reassign-dialog {
  .inform-scope-content {
    width: 440px;
    display: flex;
    justify-content: space-between;
    .left {
      width: 120px;
      .el-icon-plus {
        color: #54ABF1;
        cursor: pointer;
        margin-left: 36px;
        &:active {
          color: #388DD2;
        }
      }
    }
    .right {
      width: calc(100% - 37px);
      line-height: 17px;
      padding-top: 6px;
      padding-left: 10px;
      .candidate-item {
        // 这个是去除前缀之前的宽度，先注释
        width: 74px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 12px;
        display: inline-block;
        margin-right: 5px;
      }
    }
    .dialog-footer {
      .el-button--mini {
        padding: 5px 24px;
      }
    }
  }
  .turnon-tip {
    margin-top: 23px;
    p {
        margin-bottom: 9px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/process/runtime/process-runtime.vue